module.exports = __webpack_public_path__ + "static/media/reciprocate.c432cb36.png";